export enum NewBuildStepsSteps {
  Fields,
  Assign,
  Name
}

